// extracted by css-extract-rspack-plugin
export default {"cls1":"ReferenceCard-cls1_2df","cls2":"ReferenceCard-cls2_dsc ReferenceCard-cls1_2df"};